import React from "react";
import "./Bienvenidos.css";

const Bienvenidos = () => {
  return (
    <section id="bienvenidos-section">
      <div className="bienvenidos-section-content">
        <div className="left-content">
          <h2>MOVIHER CONTRATISTAS GENERALES S.A.C.</h2>
          <p>Con dos décadas de experiencia, somos líderes en Perú en la construcción de proyectos residenciales, industriales y comerciales. Destacamos por nuestra calidad y compromiso, respaldados por un equipo altamente calificado. Nuestro éxito radica en la plena satisfacción de nuestros clientes, siendo su confianza nuestro mayor logro.</p>
        </div>
      </div>
    </section>
  );
};

export default Bienvenidos;
